import axios from 'axios/index'

const namespaced = true

const state = {
  groupsUsers: [],
  companyInfo: null,
  modalParamsCompany: null,
  modalParamsSubgroup: null,
  modalParamsUser: null,
  serverAlias: null,
  groupsUsersItem: null,
  groupDropdowns: null,
  subgroupDropdowns: null,
  userDropdowns: null,
  modalParamsGroupFCS: null,
  isBusy: null,
  busyModalTable: null,
  billingParamsStatic: null,
  billingDropdowns: null,
  infodecData: null,
  clientsProgrammData: null,
  dealers: null,
  dealersList: null,
  notificationStatuses: null,
  onlinePermissions: null,
  packageTypes: null,
  filterStatus: null,
  filterDate: null,
  filterDealer: null,
  filterOnline: null,
  billingTypes: null
}
const actions = {
  getGroupsUsers ({ commit }, isGroupsReload = true) {
    commit('busyState', isGroupsReload)
    return axios.get('/api/private/v3.0/piportals/all/groups/')
      .then(response => {
        commit('setGroupsUsers', response.data)
        commit('busyState', false)
      })
      .catch(error => {
        console.log(error)
        commit('busyState', false)
      })
  },
  getGroupDropdowns ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.server + '/group/dropdowns/')
      .then(response => {
        commit('setGroupDropdowns', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getGroupModalParams ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.server_alias + '/groups/' + data.p_gid + '/')
      .then(response => {
        commit('setGroupModalParams', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createGroup ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post('/api/private/v3.0/piportals/' + state.groupsUsersItem.server + '/groups/', data)
        .then(response => {
          commit('addCreatedGroup', response.data)
          response.data.objtype = 'group'
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editGroup ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/', data)
        .then(response => {
          commit('addEditedGroup', response.data)
          response.data.objtype = 'group'
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getUserDropdowns ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.server_alias + '/user/dropdowns/')
      .then(response => {
        commit('setUserDropdowns', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getUserModalParams ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.alias + '/users/' + data.p_id + '/')
      .then(response => {
        commit('setUserParams', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createUser ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/users/',
        data: data
      })
        .then(response => {
          response.data.objtype = 'user'
          response.data.parent_p_gid = data.parent_p_gid
          response.data.p_gid = data.p_gid
          commit('addCreatedUser', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editUser ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/private/v3.0/piportals/' + state.groupsUsersItem.alias + '/users/' + state.groupsUsersItem.p_id + '/', data)
        .then(response => {
          response.data.objtype = 'user'
          response.data.parent_p_gid = data.parent_p_gid
          response.data.p_gid = data.p_gid
          commit('addEditedUser', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getSubgroupDropdowns ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.server_alias + '/subgroup/dropdowns/')
      .then(response => {
        commit('setSubgroupDropdowns', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getSubgroupModalParams ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.alias + '/subgroups/' + data.p_gid + '/')
      .then(response => {
        commit('setSubgroupModalParams', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createSubgroup ({ state }, data) {
    return new Promise((resolve, reject) => {
      axios.post('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/subgroups/', data)
        .then(response => {
          response.data.objtype = 'subgroup'
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editSubgroup ({ state }, data) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/private/v3.0/piportals/' + state.groupsUsersItem.alias + '/subgroups/' + state.groupsUsersItem.p_gid + '/', data)
        .then(response => {
          response.data.objtype = 'subgroup'
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getGroupFCSData ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/fcs-profile/')
      .then(response => {
        commit('setGroupFCSModalParams', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  editFCSData ({ state, commit }, data) {
    console.log('data in editFCSData ', data)
    return axios.patch('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/fcs-profile/', data)
      .then(response => {
        data.p_gid = response.data.client_id
        commit('addFcsProfile', data)
        commit('setActiveElement', data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getSubgroupFCSData ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + state.groupsUsersItem.alias + '/subgroups/' + state.groupsUsersItem.p_gid + '/fcs-profile/')
      .then(response => {
        commit('setGroupFCSModalParams', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  editSubgroupFCSData ({ state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/private/v3.0/piportals/' + state.groupsUsersItem.alias + '/subgroups/' + state.groupsUsersItem.p_gid + '/fcs-profile/', data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getBillingProfile ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/billing-profile/')
      .then(response => {
        commit('setBillingStatic', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getBillingDropdowns ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/billing-profile/controls/')
      .then(response => {
        commit('setBillingDropdowns', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createCustomSubscribe ({ state }, data) {
    return axios.post('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/billing-profile/custom-subscribe/', data)
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createServiceUnlim ({ state }, data) {
    return axios.post('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/billing-profile/service-unlim/', data)
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createFullUnlim ({ state }, data) {
    return axios.post('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/billing-profile/full-unlim/', data)
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  sendToArchive ({ dispatch }, data) {
    return axios.post('/api/private/v3.0/piportals/' + data.server_alias + '/groups/' + data.p_gid + '/archive-status-invert/')
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getDataFromOrg ({ rootState, commit }, data) {
    let dealerId = rootState.authorization.userInfo.company.org_id
    if (dealerId === 999) {
      dealerId = 77
    } else if (dealerId === 139 || dealerId === 138) {
      dealerId = 53
    }

    commit('busyStateModal', true)
    return axios.get('/api/private/v3.0/dealers/' + dealerId + '/inns/' + data.inn + '/kpps/' + data.kpp + '/orgid-clients/')
      .then(response => {
        commit('busyStateModal', false)
        commit('setDataFromOrg', response.data)
      })
      .catch(error => {
        commit('busyStateModal', false)
        commit('setDataFromOrg', null)
        console.log(error)
      })
  },
  getDataFromInfodec ({ rootState, commit }, data) {
    commit('busyStateModal', true)
    return axios.get('/api/private/v3.0/dealers/' + rootState.authorization.userInfo.company.org_id + '/inns/' + data.inn + '/kpps/' + data.kpp + '/fcs-operators/infodec/')
      .then(response => {
        commit('busyStateModal', false)
        commit('setDataFromInfodec', response.data)
      })
      .catch(error => {
        commit('busyStateModal', false)
        console.log(error)
      })
  },
  getAllDealersGroups ({ commit }, dataObj) {
    commit('busyState', dataObj.reload)
    return axios.get('/api/private/v3.0/piportals/all/groups/all/?server_alias=' + dataObj.server)
      .then(response => {
        if (response.data.length > 1) {
          response.data.map((item, index) => {
            if (index > 0) {
              response.data[0].groups_data = response.data[0].groups_data.concat(item.groups_data)
            }
          })
        }
        commit('setGroupsUsers', response.data[0])
        commit('busyState', false)
      })
      .catch(error => {
        console.log(error)
        commit('busyState', false)
      })
  },
  getAllDealers ({ commit }, data) {
    return axios.get('/api/private/v3.0/piportals/all/groups/all-dealers/?server_alias=' + data)
      .then(response => {
        commit('setDealersList', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getDealers ({ commit }, data) {
    return axios.get('/api/private/v3.0/piportals/all/groups/dealers/?server_alias=' + data)
      .then(response => {
        commit('setDealersList', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getNotificationStatuses ({ commit }) {
    return axios.get('/api/private/v3.0/notification-statuses/')
      .then(response => {
        commit('setNotificationStatuses', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getOnlinePermissions ({ commit }) {
    return axios.get('/api/private/v3.0/piportals/online/permissions/')
      .then(response => {
        commit('setOnlinePermissions', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getPackageTypes ({ commit }) {
    return axios.get('/api/private/v3.0/piportals/all/users/package-type-rights/')
      .then(response => {
        commit('setPackageTypes', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  downloadExcelFile (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v3.0/piportals/all/groups/all/xlsx-report/',
        params: data,
        responseType: 'blob'
      })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getBillingTypes ({ commit }) {
    return axios.get('/api/private/v3.0/billing-types/')
      .then(response => {
        commit('setBillingTypes', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  loadDataFromXml ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        url: `/api/private/v3.0/piportals/${state.groupsUsersItem.server_alias || state.groupsUsersItem.alias}/${data.groupType}/${data.groupId}/fcs-profile/`,
        data: data.formData
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
const mutations = {
  addFcsProfile (state, data) {
    const foundIndex = state.groupsUsers.findIndex(x => x.p_gid === data.p_gid)
    state.groupsUsers[foundIndex].participant_id = (data.p_participant_id !== null ? data.p_participant_id : 'Даобит')
  },
  addEditedUser (state, data) {
    if (data.parent_p_gid !== null) {
      const foundGroupIndex = state.groupsUsers.findIndex(x => x.p_gid === data.parent_p_gid)
      const foundSubgroupIndex = state.groupsUsers[foundGroupIndex].subgroups_json.findIndex(y => y.p_gid === data.p_gid)
      const foundUserIndex = state.groupsUsers[foundGroupIndex].subgroups_json[foundSubgroupIndex].users.findIndex(y => y.p_id === data.p_id)
      state.groupsUsers[foundGroupIndex].subgroups_json[foundSubgroupIndex].users[foundUserIndex] = data
    } else {
      const foundIndex = state.groupsUsers.findIndex(x => x.p_gid === data.p_gid)
      const foundUserIndex = state.groupsUsers[foundIndex].users_json.findIndex(y => y.p_id === data.p_id)
      state.groupsUsers[foundIndex].users_json[foundUserIndex] = data
    }
  },
  addCreatedUser (state, data) {
    if (data.parent_p_gid !== null) {
      const foundGroupIndex = state.groupsUsers.findIndex(x => x.p_gid === data.parent_p_gid)
      const foundSubgroupIndex = state.groupsUsers[foundGroupIndex].subgroups_json.findIndex(y => y.p_gid === data.p_gid)
      state.groupsUsers[foundGroupIndex].subgroups_json[foundSubgroupIndex].users.push(data)
    } else {
      const foundIndex = state.groupsUsers.findIndex(x => x.p_gid === data.p_gid)
      state.groupsUsers[foundIndex].users_json.push(data)
    }
  },
  addCreatedGroup (state, data) {
    state.groupsUsers.unshift(data)
  },
  addEditedGroup (state, data) {
    const foundIndex = state.groupsUsers.findIndex(x => x.p_gid === data.p_gid)
    state.groupsUsers[foundIndex] = Object.assign(state.groupsUsers[foundIndex], data)
  },
  setGroupsUsers (state, data) {
    if (data) {
      data.groups_data.forEach(function (elm) {
        elm._showDetails = false
      })
      state.groupsUsers = data.groups_data.sort((a, b) => {
        const parseA = a.create_date.split('.');
        [parseA[0], parseA[1]] = [parseA[1], parseA[0]]
        const parseB = b.create_date.split('.');
        [parseB[0], parseB[1]] = [parseB[1], parseB[0]]
        return new Date(Date.parse(parseB.join('.'))) - new Date(Date.parse(parseA.join('.')))
      })
    } else {
      state.groupsUsers = []
    }
    state.isBusy = false
  },
  setActiveElement (state, data) {
    let setElement
    if (data.objtype === 'subgroup') {
      setElement = state.groupsUsers.filter(function (item) {
        if (item.subgroups_json.find(subItem => subItem.p_gid === data.p_gid)) {
          item._showDetails = true
          item.subgroups_json.forEach(subgroup => {
            if (subgroup.p_gid === data.p_gid) {
              subgroup.class = 'active'
              setTimeout(function () {
                subgroup.class = 'nonactive'
                state.groupsUsers = state.groupsUsers.filter(function (elm) {
                  return elm
                })
              }, 3000)
            }
          })
        }
        return item
      })
    } else {
      setElement = state.groupsUsers.filter(function (item) {
        if ((item.p_gid === data.p_gid) || (item.p_gid === data.parent_p_gid)) {
          item._showDetails = true
          if (data.objtype === 'group') {
            item.subgroups_json.forEach(subgroup => {
              if (subgroup.p_gid === data.p_gid) {
                subgroup.class = 'active'
                setTimeout(function () {
                  subgroup.class = 'nonactive'
                  state.groupsUsers = state.groupsUsers.filter(function (elm) {
                    return elm
                  })
                }, 3000)
              }
            })
          } else if (data.objtype === 'user') {
            const user = []
            let userFull = []
            item.subgroups_json.forEach(function (subgroup) {
              subgroup.users.forEach(function (elm) {
                user.push(elm)
              })
            })
            userFull = user.concat(item.users_json)
            userFull.forEach(function (user) {
              if (user.p_id === data.p_id) {
                user.class = 'active'
                setTimeout(function () {
                  user.class = 'nonactive'
                  state.groupsUsers = state.groupsUsers.filter(function (elm) {
                    return elm
                  })
                }, 3000)
              }
            })
          }
        }
        return item
      })
    }
    state.groupsUsers = setElement
  },
  setGroupModalParams (state, data) {
    state.modalParamsCompany = data
  },
  setGroupDropdowns (state, data) {
    state.groupDropdowns = data
  },
  setSubgroupModalParams (state, data) {
    state.modalParamsSubgroup = data
  },
  setSubgroupDropdowns (state, data) {
    state.subgroupDropdowns = data
  },
  setUserDropdowns (state, data) {
    state.userDropdowns = data
  },
  setUserParams (state, data) {
    state.modalParamsUser = data
  },
  setGroupFCSModalParams (state, data) {
    state.modalParamsGroupFCS = data
  },
  dataFromGroupsUsersItem (state, data) {
    state.groupsUsersItem = data
  },
  setBillingStatic (state, data) {
    state.billingParamsStatic = data
  },
  setBillingDropdowns (state, data) {
    state.billingDropdowns = data
  },
  busyState (state, data) {
    state.isBusy = data
  },
  busyStateModal (state, data) {
    state.busyModalTable = data
  },
  setDataFromOrg (state, data) {
    state.clientsProgrammData = data
  },
  setDataFromInfodec (state, data) {
    state.infodecData = data
  },
  setAllDealers (state, data) {
    data[0].groups_data.forEach(function (elm) {
      elm._showDetails = false
    })
    state.dealers = data[0].groups_data.sort((a, b) => {
      const parseA = a.create_date.split('.');
      [parseA[0], parseA[1]] = [parseA[1], parseA[0]]
      const parseB = b.create_date.split('.');
      [parseB[0], parseB[1]] = [parseB[1], parseB[0]]
      return new Date(Date.parse(parseB.join('.'))) - new Date(Date.parse(parseA.join('.')))
    })
    state.isBusy = false
  },
  setDealersList (state, data) {
    data.unshift({
      fullname: 'Все дилеры',
      gid: null
    })
    state.dealersList = data
  },
  setNotificationStatuses (state, data) {
    data.map((item) => {
      item.label = item.name
      return item
    })
    state.notificationStatuses = data
  },
  setOnlinePermissions (state, data) {
    data.all_permissions.map((item) => {
      item.label = item.group_description ? item.group_description : item.name
      return item
    })
    state.onlinePermissions = data.all_permissions
  },
  setPackageTypes (state, data) {
    state.packageTypes = data
  },
  setFilterStatus (state, data) {
    state.filterStatus = data
  },
  setFilterDate (state, data) {
    state.filterDate = data
  },
  setFilterDealer (state, data) {
    state.filterDealer = data
  },
  setFilterOnline (state, data) {
    state.filterOnline = data
  },
  setBillingTypes (state, data) {
    state.billingTypes = data
  }
}
const getters = {
  filteredGroupsUsers (state) {
    return state.groupsUsers
      .filter(item => item.access_status === (state.filterStatus ? state.filterStatus : item.access_status))
      .filter(item => item.parent_id === (state.filterDealer ? state.filterDealer : item.parent_id))
      .filter(item => {
        if (state.filterOnline) {
          if ((item.users_json.length > 0 && item.users_json.some(x => x.in_online)) || (item.subgroups_json.length > 0 && item.subgroups_json.some(x => x.users.length > 0 && x.users.some(y => y.in_online)))) {
            return item
          }
        } else return item
      })
      .filter(item => {
        if (state.filterDate && state.filterDate.start && state.filterDate.end) {
          let dCreate = item.create_date.split(' ')
          const justDate = dCreate[0].split('.');
          [justDate[0], justDate[2]] = [justDate[2], justDate[0]]
          dCreate[0] = justDate.join('-')
          dCreate = new Date(Date.parse(dCreate.join(' ')))
          return dCreate >= new Date(Date.parse(state.filterDate.start)) &&
              dCreate <= new Date(Date.parse(state.filterDate.end))
        } else return item
      })
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
